/* This file was generated by running "node scripts/generateTranslations.js". */
/* Created: 2024-09-25 10:01:34 */

const Keys = { dropzoneText: 'dropzoneText', selectedFileText: 'selectedFileText' }; export default Keys;